import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";

import api from "@helpers/api.js";

import CustomModal from "@components/CustomModal/index.js";

import * as Material from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

import {Button} from '@fragments'

import communityEvents from "./events.js";
import patterns from "./patterns.js";
import { ca } from "date-fns/locale";

const CommunityContext = createContext({ signed: false });

export const CommunityProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const [communities, setCommunities] = useState(null);

  const [Modal_removeMemberOpen, setModal_removeMemberOpen] = useState(null);

  const REF_callbackOnLoaded = useRef(() => { });
  const REF_initialized = useRef(false);

  useEffect(() => {
    if (!loading && communities && REF_callbackOnLoaded.current) {
      REF_callbackOnLoaded.current(communities);
    }
  }, [communities]);

  useEffect(() => {
    if (loading && !REF_initialized.current) {
      REF_initialized.current = true;
      loadCommunities();
    }
  }, [loading]);

  function prepareCommunity(community) {
    return {
      ...community,
      isAdmin() {
        return ["owner", "creator"].includes(community.role);
      },
    };
  }

  async function loadCommunities(callback = () => { }) {
    setLoading(true);
    try {
      let { data } = await api.get("/community/subscribed");
      data = data.map(prepareCommunity);
      setCommunities([...data]);
      REF_callbackOnLoaded.current = callback;
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleOpenRemoveMemberTool(user) {
    setModal_removeMemberOpen({ ...user });
  }

  const community = {
    management: {
      open(info) {
        window.navigate(`${info.slug}/settings`);
      },
      openGroup(info) {
        communityEvents.triggerModal.configGroup(info);
      },
      async create() {
        try {
          const { data } = await api.post("community", {
            monetization_type: 'FREE',
            name: 'Minha comunidade',
          });
          if (data.id) {
            await loadCommunities(() => window.navigate("/" + data.slug))
          }
        } catch (e) {

        }
      },
    },

    triggerShareModal(id) {
      console.log(id, this.get(id), communities);
      window.handleOpenShareContentModal({
        title:
          'Compartilhe a comunidade "' +
          this.get(id)?.name +
          '" nas redes sociais',
        link: this.get(id)?.invite_url,
      });
    },

    open(id) {
      window.navigate("/" + id);
    },

    get(id) {
      return communities?.filter((c) => c.id === id)[0];
    },

    getBySlug(slug) {
      return communities?.filter((c) => c.slug === slug)[0];
    },

    async subscribe(id, callback) {
      const { data } = await api.post(`community/join`, { community_id: id });
      callback();
      return data;
    },
    async unsubscribe(id, callback) {
      const { data } = await api.delete(`community/leave`, { community_id: id });
      callback();
      return data;
    },

    async load(value, key = 'id') {
      try {
        const { data } = await api.get(`community?${key}=${value}`);
        return prepareCommunity(data);
      } catch (e) {
        console.log(e);
      }
    },


    group: {
      pattern: patterns.group,

      get(id) {
        console.log(communities, id);
        return communities?.filter((c) => c.groups?.filter((g) => g.id === id)[0])[0]?.groups?.filter((g) => g.id === id)[0];
      },
    },

    hasAccessToGroup(community, groupId) {
      try {
        const comm = this.get(community);
        if (comm.isAdmin()) return true;

        const group = comm.groups.filter((g) => g.id === groupId)[0];
        return (
          !group.availability ||
          group.availability.includes(comm.subscription?.plan?.id) ||
          group.availability[0] === "all"
        );
      } catch (e) {
        return false
      }
    },
    hasAccessToCourse(community, courseId) {
      try {
        const comm = this.get(community);

        if (comm?.isAdmin()) return true;

        const course = comm.courses?.filter((g) => g.id === courseId)[0];
        return (
          !course.availability ||
          course.availability.includes(comm.subscription?.plan?.id) ||
          course.availability[0] === "all"
        );
      } catch (e) {
        return false
      }
    },

    hasAtLeastOneAdminPermission:
      communities?.filter((c) => c.isAdmin())?.length > 0,
  };

  return (
    <CommunityContext.Provider
      value={{
        loading,
        setLoading,

        communities,

        community,

        loadCommunities,

        handleOpenRemoveMemberTool,
      }}
    >
      {loading && (
        <Material.LinearProgress
          infinite
          className="top-screen-loader"
          color="secondary"
        />
      )}
      {children}

      <ModalRemoveMember
        key={Math.random()}
        open={!!Modal_removeMemberOpen}
        setOpen={setModal_removeMemberOpen}
        user={Modal_removeMemberOpen}
      />
    </CommunityContext.Provider>
  );
};

export default CommunityContext;

export function useCommunity() {
  const context = useContext(CommunityContext);

  if (!context) {
    throw new Error("useCommunity must be used within an CommunityProvider.");
  }

  return context;
}

const ModalRemoveMember = ({ open, setOpen, user }) => {
  const [confirmText, setConfirmText] = useState();
  const [loading, setLoading] = useState(false);

  const firstName = user?.username?.split(" ")[0];

  const { currentChallenge } = useCommunity();

  async function handleRemoveUser() {
    setLoading(true);

    try {
      const result = await api.delete("challenge/members", {
        challenge_id: user.challenge_id,
        user_id: user.id,
      });

      if (result.data.success) {
        window.setSnackbar("Usuário removido com sucesso");
        setOpen(false);
        user.onDelete();
      } else {
        window.setSnackbar(
          "Houve um erro ao remover este usuário, tente novamente mais tarde"
        );
      }
    } catch (e) {
      window.setSnackbar(
        "Houve um erro ao remover este usuário, tente novamente mais tarde"
      );
    }

    setLoading(false);
  }

  return (
    <CustomModal
      maxWidth={400}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={false}
      title="Remover participante"
      handleSubmit={() => { }}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container">
          <h3>Atenção!</h3>
          <h4 className="mt-1 pb-1">
            Você realmente deseja remover o participante {user?.username} do
            desafio?
          </h4>
          <label className="pt-1">
            Ao fazer isso, este participante perderá imediatamente acesso ao
            aplicativo, e seus pontos desaparecerão do ranking
          </label>
          <label className="pt-4">
            Para confirmar essa ação, digite <em>"{firstName}"</em> abaixo
          </label>
          <Material.TextField
            value={confirmText}
            onChange={(v) => setConfirmText(v.target.value)}
            placeholder={firstName}
            fullWidth
          />
          <div className="bottom-buttons-delete-member-modal mt-3">
            <Button
              onClick={handleRemoveUser}
              label={"Remover " + firstName + " permanentemente"}
              color="error"
              endIcon={<DeleteIcon color="error" />}
              disabled={
                firstName?.toLowerCase() !== confirmText?.toLowerCase() ||
                loading
              }
            />
          </div>{" "}
        </div>
      }
      modalClass="select-challenge-modal"
      bottomButtonsOrientation="vertical"
    />
  );
};
